import { createSlice } from "@reduxjs/toolkit";
import { clearHeaders, setHeaders } from "../../utils/http";

const initialState = {
	currentAuthenticatedUser: null,
};

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		signIn: (state, action) => {
			state.currentAuthenticatedUser = action.payload;
			setHeaders({ Authorization: action.payload.authorization, idToken: action.payload.idToken });
		},
		signOut: (state) => {
			state.currentAuthenticatedUser = null;
			clearHeaders();
		},
	},
});

export const { signIn, signOut } = authSlice.actions;

export default authSlice.reducer;
